import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { groupBy } from "lodash";
import moment from "moment";
import Checkbox from "./../common/Checkbox";
import Input from "./../common/Input";
import Select from "./../common/Select";
import BackIcon from "./../common/BackIcon";
import {
  getIndividualSupervisionLog,
  saveIndividualSupervisionLog,
  getMyCaseload,
  sendEmail,
} from "../services/soar";
import { openPDF } from "../../scripts/helperScripts";
import SearchBox from "../common/SearchBox";

function IndividualSupervisionLog(props) {
  const navigate = useNavigate();
  const location = useLocation();
  const { supervisionLogId } = useParams();
  const [data, setData] = useState({});
  // const [timeoutId, setTimeoutId] = useState({});
  const [touched, setTouched] = useState({});
  const [caseload, setCaseload] = useState([]);
  const [caseloadSearch, setCaseloadSearch] = useState("");
  const isMountedRef = useRef(true);
  const [caseloadClient, setCaseloadClient] = useState();
  const [adHocClient, setAdHocClient] = useState();
  const safyInfo = JSON.parse(localStorage.getItem("safyInfo"));
  const portal =
    process.env.REACT_APP_ENVIRONMENT === "Production"
      ? "https://safyportal.safy.org/share"
      : "https://safyportaltest.safy.org/share";
  const isNotSupervisor =
    data &&
    data.SupervisorUser &&
    data.SupervisorUser.toLowerCase() !==
      safyInfo.user.domainName.split("\\")[1].toLowerCase();

  const supervisorSigned =
    data.Signatures &&
    data.Signatures.signatures &&
    data.Signatures.signatures[0] &&
    data.Signatures.signatures[0].date;
  const superviseeSigned =
    data.Signatures &&
    data.Signatures.signatures &&
    data.Signatures.signatures[1] &&
    data.Signatures.signatures[1].date;

  const timeOptions = [
    { name: "0:15", _id: "15" },
    { name: "0:30", _id: "30" },
    { name: "0:45", _id: "45" },
    { name: "1:00", _id: "60" },
    { name: "1:15", _id: "75" },
    { name: "1:30", _id: "90" },
    { name: "1:45", _id: "105" },
    { name: "2:00", _id: "120" },
    { name: "2:15", _id: "135" },
    { name: "2:30", _id: "150" },
    { name: "2:45", _id: "165" },
    { name: "3:00", _id: "180" },
  ];

  const pdfRef = useRef(true);

  useEffect(() => {
    if (isMountedRef.current) {
    }
    return () => {
      isMountedRef.current = false;
      pdfRef.current = false;
    };
  }, []);

  useEffect(() => {
    if (isMountedRef.current) {
      setData({});
      getIndividualSupervisionLog(supervisionLogId).then((response) => {
        console.log("Supervision Log:", JSON.parse(response));
        if (response) {
          let obj = JSON.parse(response).SupervisorLogs.SupervisorLog[0];
          obj.CountsAsLicensure = obj.CountsAsLicensure === "1" ? true : false;
          obj.ClinicalSupervision =
            obj.ClinicalSupervision === "1" ? true : false;
          obj.AdministrativeSupervision =
            obj.AdministrativeSupervision === "1" ? true : false;

          if (obj.Comments && obj.Comments.comment) {
            if (!Array.isArray(obj.Comments.comment)) {
              obj.Comments = [obj.Comments.comment];
            } else {
              obj.Comments = obj.Comments.comment;
            }
          } else {
            obj.Comments = [];
          }

          if (obj.DynamicData && obj.DynamicData != null) {
            //CASE REVIEWW
            if (obj.DynamicData.CaseReviews) {
              if (Array.isArray(obj.DynamicData.CaseReviews.case)) {
                obj.CaseReviews = obj.DynamicData.CaseReviews.case;
              } else {
                obj.CaseReviews = [obj.DynamicData.CaseReviews.case];
              }
            }

            //Documentation Fidelity
            if (obj.DynamicData.DocumentationFidelity) {
              if (
                Array.isArray(
                  obj.DynamicData.DocumentationFidelity.documentation
                )
              ) {
                obj.DocumentationFidelity =
                  obj.DynamicData.DocumentationFidelity.documentation;
              } else {
                obj.DocumentationFidelity = [
                  obj.DynamicData.DocumentationFidelity.documentation,
                ];
              }
            }

            //Administrative
            if (obj.DynamicData.Administration) {
              if (
                Array.isArray(obj.DynamicData.Administration.administrative)
              ) {
                obj.Administration =
                  obj.DynamicData.Administration.administrative;
              } else {
                obj.Administration = [
                  obj.DynamicData.Administration.administrative,
                ];
              }
            }

            if (obj.DynamicData.IdentifiedResources) {
              obj.IdentifiedResources = obj.DynamicData.IdentifiedResources;
            }
            if (obj.DynamicData.SelfCare) {
              obj.SelfCare = obj.DynamicData.SelfCare;
            }
          }
          setData(obj);
        }
      });
    }
  }, [supervisionLogId]);

  useEffect(() => {
    if (isMountedRef.current && data.SuperviseeUser) {
      getMyCaseload(data.SuperviseeUser).then((response) => {
        if (response) {
          const grouped = Object.values(groupBy(response, "con.contactid"));
          let options = grouped.map((client) => {
            return {
              name: client[0]["con.fullname"],
              _id: client[0]["con.contactid"],
            };
          });
          options = options.sort((a, b) => a["name"].localeCompare(b["name"]));
          setCaseload(options);
        }
      });
    }
  }, [data.SuperviseeUser]);

  const handleChange = ({ currentTarget: input }, table, index, field) => {
    // let newTimeoutId;
    const obj = { ...data };
    if (table && field && index !== undefined) {
      obj[table][index][field] = input.value;
    } else {
      obj[input.name] = input.type === "checkbox" ? input.checked : input.value;
      console.log(
        "handleChange",
        input.name,
        input.type === "checkbox" ? input.checked : input.value,
        typeof input.value
      );
    }
    setData(obj);

    // if (timeoutId) clearTimeout(timeoutId);

    // const touchedObj = { ...touched, [input.name]: true };
    // const touchedFields = Object.keys(touchedObj).filter(
    //   (field) => touchedObj[field]
    // );

    // if (touchedFields.length >= 5) {
    //   // clearTimeout(timeoutId);
    //   handleSave(obj);
    //   touchedFields.forEach((field) => (touchedObj[field] = false));
    // }
    // else
    //   newTimeoutId = setTimeout(() => {
    //     touchedFields.forEach((field) => (touchedObj[field] = false));
    //     handleSave();
    //   }, 20000);

    // setTimeoutId(newTimeoutId);

    //setTouched(touchedObj);
  };

  const addCaseReviewClient = () => {
    if (
      (adHocClient && adHocClient !== "") ||
      (caseloadClient && caseloadClient !== "")
    ) {
      const obj = { ...data };
      if (!obj.CaseReviews) {
        obj.CaseReviews = [];
      }
      const review = {
        clientName:
          adHocClient ||
          caseload.filter((c) => c._id === caseloadClient)[0].name,
        clientId: caseloadClient || "",
        caseReview: "",
        concerns: "",
        followup: "",
      };
      obj.CaseReviews.push(review);
      setData(obj);
      setCaseloadClient("");
      setAdHocClient("");
    } else {
      toast.error("You must select a client");
    }
  };

  const addDocumentationFidelity = () => {
    const obj = { ...data };
    if (!obj.DocumentationFidelity) {
      obj.DocumentationFidelity = [];
    }
    const documentation = {
      item: "",
      notes: "",
      followup: "",
    };
    obj.DocumentationFidelity.push(documentation);
    setData(obj);
  };

  const addAdministration = () => {
    const obj = { ...data };
    if (!obj.Administration) {
      obj.Administration = [];
    }
    const admin = {
      item: "",
      notes: "",
      followup: "",
    };
    obj.Administration.push(admin);
    setData(obj);
  };

  const addComment = () => {
    const obj = { ...data };
    if (!obj.Comments) {
      obj.Comments = [];
    }

    const comment = {
      createdBy: safyInfo.user.displayName,
      createdOn: new Date(),
      message: obj.addComment,
    };
    obj.Comments.push(comment);
    obj.addComment = "";
    setData(obj);
    handleSave(obj);
    sendEmail(
      [`${data.SuperviseeUser}@safy.org`, `${data.SupervisorUser}@safy.org`],
      "",
      "Supervision Log Comment",
      `${comment.createdBy} has added the comment "${comment.message}" to the Supervision log at ${window.location.origin}/share${location.pathname}`
    );
  };

  const handleSave = (dataOverride) => {
    const dataObj = dataOverride || { ...data };

    const obj = {
      LogId: dataObj.LogId,
      SupervisorUser: dataObj.SupervisorUser,
      SupervisorName: dataObj.SupervisorName,
      SuperviseeUser: dataObj.SuperviseeUser,
      SuperviseeName: dataObj.SuperviseeName,
      DateCompleted: dataObj.DateCompleted || new Date(),
      LengthOfSupervision: dataObj.LengthOfSupervision
        ? parseInt(dataObj.LengthOfSupervision).toString()
        : null,
      LengthOfLicensure: dataObj.LengthOfLicensure
        ? parseInt(dataObj.LengthOfLicensure).toString()
        : null,
      ClinicalSupervision: dataObj.ClinicalSupervision === true ? 1 : 0,
      AdministrativeSupervision:
        dataObj.AdministrativeSupervision === true ? 1 : 0,
      CountsAsLicensure: dataObj.CountsAsLicensure || null,
      OtherComments: dataObj.OtherComments || null,
      DynamicData: `<CaseReviews>${convertTableToXml(
        dataObj.CaseReviews || [],
        "case"
      )}</CaseReviews><DocumentationFidelity>${convertTableToXml(
        dataObj.DocumentationFidelity || [],
        "documentation"
      )}</DocumentationFidelity><Administration>${convertTableToXml(
        dataObj.Administration || [],
        "administrative"
      )}</Administration><IdentifiedResources>${
        dataObj.IdentifiedResources || ""
      }</IdentifiedResources><SelfCare>${dataObj.SelfCare || ""}</SelfCare>`,
      Comments: `${convertTableToXml(dataObj.Comments || [], "comment")}`,
      Signatures: `${convertSignatures(dataObj.Signatures.signatures)}`,
      CreatedById: dataObj.CreatedById,
      ModifiedById: safyInfo.user.domainName.split("\\")[1].toLowerCase(),
    };

    console.log("Saving form", obj);

    saveIndividualSupervisionLog(obj, "Update").then((response) => {
      const rjson = JSON.parse(response);
      if (
        rjson &&
        rjson.SystemResponse &&
        rjson.SystemResponse[0].Code &&
        rjson.SystemResponse[0].Code === "SUCCESS"
      )
        toast.success("Form Saved Successfully");
      else
        toast.error(
          "There was a problem saving the form. ",
          rjson.SystemResponse[0].Message
        );
    });
  };

  const handleDelete = () => {
    const obj = {
      LogId: data.LogId,
      SupervisorUser: data.SupervisorUser,
      SupervisorName: data.SupervisorName,
      SuperviseeUser: data.SuperviseeUser,
      SuperviseeName: data.SuperviseeName,
      DateCompleted: data.DateCompleted || new Date(),
      LengthOfSupervision: data.LengthOfSupervision
        ? parseInt(data.LengthOfSupervision)
        : null,
      LengthOfLicensure: data.LengthOfLicensure
        ? parseInt(data.LengthOfLicensure)
        : null,
      ClinicalSupervision: data.ClinicalSupervision === true ? 1 : 0,
      AdministrativeSupervision:
        data.AdministrativeSupervision === true ? 1 : 0,
      CountsAsLicensure: data.CountsAsLicensure || null,
      DynamicData: `<CaseReviews>${convertTableToXml(
        data.CaseReviews || [],
        "case"
      )}</CaseReviews><DocumentationFidelity>${convertTableToXml(
        data.DocumentationFidelity || [],
        "documentation"
      )}</DocumentationFidelity><Administration>${convertTableToXml(
        data.Administration || [],
        "administrative"
      )}</Administration><IdentifiedResources>${
        data.IdentifiedResources || ""
      }</IdentifiedResources><SelfCare>${data.SelfCare || ""}</SelfCare>`,
      Comments: `${convertTableToXml(data.Comments || [], "comment")}`,
      Signatures: `${convertSignatures(data.Signatures.signatures)}`,
      CreatedById: data.CreatedById,
      ModifiedById: safyInfo.user.domainName.split("\\")[1].toLowerCase(),
    };
    saveIndividualSupervisionLog(obj, "Delete").then((response) => {
      const rjson = JSON.parse(response);
      if (
        rjson &&
        rjson.SystemResponse &&
        rjson.SystemResponse[0].Code &&
        rjson.SystemResponse[0].Code === "SUCCESS"
      ) {
        toast.success("Form Deleted Successfully");
        navigate("/supervision", { replace: true });
      } else
        toast.error(
          "There was a problem deleting the form. ",
          rjson.SystemResponse[0].Message
        );
    });
  };

  const handleClone = () => {
    const obj = {
      LogId: null,
      SupervisorUser: data.SupervisorUser,
      SupervisorName: data.SupervisorName,
      SuperviseeUser: data.SuperviseeUser,
      SuperviseeName: data.SuperviseeName,
      DateCompleted: new Date(),
      LengthOfSupervision: null,
      LengthOfLicensure: null,
      ClinicalSupervision: data.ClinicalSupervision === true ? 1 : 0,
      AdministrativeSupervision:
        data.AdministrativeSupervision === true ? 1 : 0,
      CountsAsLicensure: data.CountsAsLicensure || null,
      OtherComments: "",
      DynamicData: `<CaseReviews>${convertTableToXml(
        data.CaseReviews || [],
        "case"
      )}</CaseReviews><DocumentationFidelity>${convertTableToXml(
        data.DocumentationFidelity || [],
        "documentation"
      )}</DocumentationFidelity><Administration>${convertTableToXml(
        data.Administration || [],
        "administrative"
      )}</Administration><IdentifiedResources>${
        data.IdentifiedResources || ""
      }</IdentifiedResources><SelfCare>${data.SelfCare || ""}</SelfCare>`,
      Comments: "<comments></comments>",
      Signatures:
        "<signatures><type>Supervisor</type></signatures><signatures><type>Supervisee</type></signatures>",
      CreatedById: safyInfo.user.domainName.split("\\")[1].toLowerCase(),
      ModifiedById: safyInfo.user.domainName.split("\\")[1].toLowerCase(),
    };

    saveIndividualSupervisionLog(obj, "Insert").then((response) => {
      const r = JSON.parse(response);
      console.log("Clone Response", r);
      if (
        r &&
        r.SystemResponse &&
        r.SystemResponse[0] &&
        r.SystemResponse[0].Id
      ) {
        setData({});
        toast.success("Supvision Log Successfully Cloned");
        navigate(`/individualsupervision/${r.SystemResponse[0].Id}`);
      } else
        toast.error(
          "There was a problem saving the form. ",
          r.SystemResponse[0].Message
        );
    });
  };

  const convertTableToXml = (table, rootName) => {
    var tableXml = "";

    if (table.length > 0) {
      for (const row in table) {
        tableXml += `<${rootName}>`;
        for (const property in table[row]) {
          let val = table[row][property] || "";
          val = val
            .toString()
            .replaceAll("&", "&amp;")
            .replaceAll(`"`, "&quot;")
            .replaceAll("'", "&apos;")
            .replaceAll("<", "&lt;")
            .replaceAll(">", "&gt;");
          tableXml += `<${property}>${val}</${property}>`;
        }
        tableXml += `</${rootName}>`;
      }
    }
    return tableXml;
  };

  const convertSignatures = (signatures) => {
    var signatureXml = "";
    if (signatures.length > 0) {
      for (const signature in signatures) {
        signatureXml += "<signatures>";
        for (const property in signatures[signature]) {
          signatureXml += `<${property}>${signatures[signature][property]}</${property}>`;
        }
        signatureXml += "</signatures>";
      }

      return signatureXml;
    }
    return "";
  };

  const handleSign = (signatureType) => {
    let obj = { ...data };
    if (signatureType === "Supervisor") {
      obj.Signatures.signatures[0] = {
        type: "Supervisor",
        user: safyInfo.user.domainName.toLowerCase(),
        name: safyInfo.user.displayName,
        date: new Date(),
      };
      sendEmail(
        `${data.SuperviseeUser}@safy.org`,
        `${data.SupervisorUser}@safy.org`,
        "Supervision Log",
        `${data.SupervisorName} has created a Supervision log for you at ${portal}${location.pathname}`
      );
    }
    if (signatureType === "Supervisee") {
      obj.Signatures.signatures[1] = {
        type: "Supervisee",
        user: safyInfo.user.domainName.toLowerCase(),
        name: safyInfo.user.displayName,
        date: new Date(),
      };
      sendEmail(
        `${data.SupervisorUser}@safy.org`,
        `${data.SuperviseeUser}@safy.org`,
        "Signed Supervision Log",
        `${data.SuperviseeName} has signed your Supervision log at ${portal}${location.pathname}`
      );
    }
    setData(obj);
    handleSave(obj);
  };

  const openClient = (id) => {
    window.open(`${window.location.origin}/client/${id}`);
  };

  const openDashboards = () => {
    const url = `${process.env.REACT_APP_ORG}/workplace/home_dashboards.aspx`;
    window.open(url);
  };

  const openPowerBI = () => {
    const url = `https://app.powerbi.com`;
    window.open(url);
  };

  const sendToPDF = () => {
    if (pdfRef && pdfRef.current) {
      console.log("PDF Ref", pdfRef.current);
      toast.warning(
        "Form being converted into PDF. This may take a little time, please do not navigate away",
        {
          position: "top-right",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          progress: undefined,
          theme: "colored",
        }
      );
      openPDF(pdfRef.current);
    }
  };

  return (
    <div ref={pdfRef}>
      <BackIcon />
      <div className="row bg-safy2-1 text-white p-4 m-0">
        <div className="col h4">Individual Supervision Log</div>
        <div className="col">
          {data.ModifiedOn !== undefined ? (
            <strong className="d-print-none" style={{ float: "right" }}>
              {` Last saved on
            ${moment
              .utc(props.lastModifiedOn)
              .local()
              .format("MMM D, YYYY [at] h:mm A")}`}
            </strong>
          ) : (
            <strong
              className="d-print-none text-warning d-flex"
              style={{ float: "right" }}
            >
              <i className="fas fa-exclamation-triangle mt-1 me-1"></i>
              To prevent loss of work, please click save.
            </strong>
          )}
        </div>
      </div>
      <div className="bg-safy2-1 text-white h6 ps-4 pb-2 m-0 row">
        <div className="col">Supervisee: {data.SuperviseeName}</div>
        <div className="col">Supervisor: {data.SupervisorName}</div>
      </div>
      <div className="bg-safy3-1 p-2 clearfix d-print-none m-0">
        <div className="float-end">
          <i
            title="Save"
            role="button"
            className="far fa-save fa-2x text-white mx-1"
            onClick={() => {
              handleSave();
            }}
          ></i>
          {!isNotSupervisor && (
            <i
              title="Clone"
              role="button"
              className="far fa-clone fa-2x text-white mx-1"
              onClick={(e) => {
                if (
                  window.confirm("Are you sure you want to clone the form?")
                ) {
                  handleClone(e);
                }
              }}
            ></i>
          )}
          {(!supervisorSigned || safyInfo.user.modules.includes("Admin")) && (
            <i
              title="Delete"
              role="button"
              className="far fa-trash-alt fa-2x text-white mx-1"
              onClick={(e) => {
                handleDelete();
              }}
            ></i>
          )}
          <i
            title="Print"
            role="button"
            className="fas fa-print fa-2x text-white mx-1"
            onClick={() => {
              sendToPDF();
            }}
          ></i>
        </div>
      </div>
      <div className="row mt-4">
        <div className="col-6">
          <Input
            name="DateCompleted"
            label="Date Completed"
            value={data.DateCompleted}
            type="date"
            onChange={handleChange}
            disabled={isNotSupervisor || supervisorSigned}
          />
        </div>
        <div className="col-6">
          <Select
            name="LengthOfSupervision"
            label="Length of Supervision Session"
            options={timeOptions}
            value={data.LengthOfSupervision}
            onChange={handleChange}
            disabled={
              isNotSupervisor ||
              (supervisorSigned && parseInt(data.LengthOfSupervision) > 0)
            }
          />
        </div>
      </div>
      <div className="row mt-2">
        <div className="col ps-4 ms-2 pt-4">
          <Checkbox
            name="CountsAsLicensure"
            label="This supervision counts towards staff licensure"
            checked={data.CountsAsLicensure === true}
            onChange={handleChange}
            disabled={isNotSupervisor || supervisorSigned}
          />
        </div>
        <div className="col">
          <Select
            name="LengthOfLicensure"
            label="Time towards Licensure Supervision (If Applicable)"
            options={timeOptions}
            value={data.LengthOfLicensure}
            onChange={handleChange}
            disabled={isNotSupervisor || supervisorSigned}
          />
        </div>
      </div>
      <div className="border px-2 pt-2 pb-0 mb-0 rounded">
        <div className="h6">Type of Supervision</div>
        <div className="row mx-4 mt-4 mb-0">
          <div className="col">
            <Checkbox
              name="ClinicalSupervision"
              label="Clinical Supervision"
              checked={data.ClinicalSupervision === true}
              onChange={handleChange}
              disabled={isNotSupervisor || supervisorSigned}
            />
          </div>
          <div className="col">
            <Checkbox
              name="AdministrativeSupervision"
              label="Administrative Supervision"
              checked={data.AdministrativeSupervision === true}
              onChange={handleChange}
              disabled={isNotSupervisor || supervisorSigned}
            />
          </div>
        </div>
      </div>
      {data && data.ClinicalSupervision === true ? (
        <div className="my-4 border rounded p-2 bg-light">
          <div className="h5 mb-4">Clinical Supervision</div>
          <div className="h6 m-2">Case Reviews</div>
          <div className="row ms-4">
            <div className="col-5">
              <SearchBox
                name="caseloadSearch"
                label={`Select from ${data.SuperviseeName}'s caseload`}
                value={caseloadSearch}
                onChange={(e) => {
                  setCaseloadSearch(e.currentTarget.value);
                }}
                clearSearch={() => setCaseloadSearch("")}
                disabled={isNotSupervisor || supervisorSigned}
              />
              <Select
                name="clientSelect"
                label={`Select from ${data.SuperviseeName}'s caseload`}
                options={caseload.filter((client) =>
                  client.name
                    .toLowerCase()
                    .includes(caseloadSearch.toLowerCase())
                )}
                value={caseloadClient}
                onChange={(e) => {
                  setAdHocClient("");
                  setCaseloadClient(e.currentTarget.value);
                }}
                disabled={isNotSupervisor || supervisorSigned}
              />
            </div>
            <div className="col-1">or</div>
            <div className="col-4">
              <Input
                name="adHocClient"
                label="Ad Hoc client"
                value={adHocClient}
                onChange={(e) => {
                  setCaseloadClient("");
                  setAdHocClient(e.currentTarget.value);
                }}
                disabled={isNotSupervisor || supervisorSigned}
              />
            </div>
            <div className="col-2 pt-2">
              {!isNotSupervisor && !supervisorSigned && (
                <div
                  className="btn btn-success mt-4 me-2 float-end"
                  onClick={() => {
                    addCaseReviewClient();
                    setCaseloadSearch("");
                  }}
                  disabled={isNotSupervisor || supervisorSigned}
                >
                  Add
                </div>
              )}
            </div>
          </div>
          <div className="mx-4 mb-4">
            <div className="row bg-safy2-1 text-white">
              <div className="col-2  py-2">Client Name</div>
              <div className="col-3  py-2">Case Review</div>
              <div className="col-3  py-2">Current Risk/Safety Concerns</div>
              <div className="col-3  py-2">Follow-Up</div>
              <div className="col-1  py-2"></div>
            </div>
            {data && data.CaseReviews
              ? data.CaseReviews.map((item, index) => {
                  return (
                    <div className="row border bg-white" key={`item${index}`}>
                      <div className="col-2  py-2">
                        {item.clientId ? (
                          <div
                            className="text-primary"
                            style={{ cursor: "pointer" }}
                            onClick={() => openClient(item.clientId)}
                          >
                            {item.clientName}
                          </div>
                        ) : (
                          item.clientName
                        )}
                      </div>
                      <div className="col-3 py-2">
                        <Input
                          name={`${index}caseReview`}
                          label=""
                          onChange={(e) =>
                            handleChange(e, "CaseReviews", index, "caseReview")
                          }
                          value={data.CaseReviews[index]["caseReview"]}
                          disabled={isNotSupervisor || supervisorSigned}
                        />
                      </div>
                      <div className="col-3 py-2">
                        <Input
                          name={`${index}concerns`}
                          label=""
                          onChange={(e) =>
                            handleChange(e, "CaseReviews", index, "concerns")
                          }
                          value={data.CaseReviews[index]["concerns"]}
                          disabled={isNotSupervisor || supervisorSigned}
                        />
                      </div>
                      <div className="col-3 py-2">
                        <Input
                          name={`${index}followup`}
                          label=""
                          onChange={(e) =>
                            handleChange(e, "CaseReviews", index, "followup")
                          }
                          value={data.CaseReviews[index]["followup"]}
                          disabled={isNotSupervisor || supervisorSigned}
                        />
                      </div>
                      <div className="col-1 py-2">
                        {!isNotSupervisor && !supervisorSigned && (
                          <i
                            className="fas fa-times-circle fa-lg text-danger"
                            onClick={(e) => {
                              let obj = { ...data };
                              obj.CaseReviews.splice(index, 1);
                              setData(obj);
                            }}
                            disabled={isNotSupervisor || supervisorSigned}
                          ></i>
                        )}
                      </div>
                    </div>
                  );
                })
              : null}
          </div>
          <div className="h6 m-2 mt-4">Identified Resources</div>
          <div className="px-2">
            <Input
              name="IdentifiedResources"
              value={data.IdentifiedResources}
              onChange={handleChange}
              disabled={isNotSupervisor || supervisorSigned}
            />
          </div>
          <div className="row p-2 mt-4">
            <div className="col-3 h6">Documentation Fidelity</div>
            <div className="col-9">
              {!isNotSupervisor && !supervisorSigned && (
                <div
                  className="btn btn-success float-end ms-4"
                  onClick={() => addDocumentationFidelity()}
                  disabled={isNotSupervisor || supervisorSigned}
                >
                  Add
                </div>
              )}
              <div
                className="btn btn-safy-info float-end mx-1"
                onClick={() => openPowerBI()}
              >
                Power BI
              </div>
              <div
                className="btn btn-safy-info float-end mx-1"
                onClick={() => openDashboards()}
              >
                Dashboard
              </div>
            </div>
          </div>
          <div className="mx-4 mb-4">
            <div className="row bg-safy2-1 text-white">
              <div className="col-3  py-2">Item</div>
              <div className="col-4  py-2">Notes</div>
              <div className="col-4  py-2">Follow-Up</div>
              <div className="col-1  py-2"></div>
            </div>
            {data && data.DocumentationFidelity
              ? data.DocumentationFidelity.map((item, index) => {
                  return (
                    <div className="row border bg-white" key={`df${index}`}>
                      <div className="col-3 py-2">
                        <Select
                          name={`${index}dfItem`}
                          options={[
                            { id: "careplan", name: "Care Plan" },
                            { id: "encounters", name: "Encounters" },
                            { id: "assessments", name: "Assessments" },
                            { id: "ir", name: "IR's" },
                            { id: "forms", name: "Forms" },
                            { id: "ebp", name: "EBP Compliance" },
                            { id: "other", name: "Other" },
                          ]}
                          value={data.DocumentationFidelity[index]["item"]}
                          onChange={(e) =>
                            handleChange(
                              e,
                              "DocumentationFidelity",
                              index,
                              "item"
                            )
                          }
                          disabled={isNotSupervisor || supervisorSigned}
                        />
                        {data &&
                        data.DocumentationFidelity &&
                        data.DocumentationFidelity[index]["item"] ===
                          "Other" ? (
                          <Input
                            name={`${index}dfother`}
                            label="Other (specify)"
                            onChange={(e) =>
                              handleChange(
                                e,
                                "DocumentationFidelity",
                                index,
                                "other"
                              )
                            }
                            value={data.DocumentationFidelity[index]["other"]}
                            disabled={isNotSupervisor || supervisorSigned}
                          />
                        ) : null}
                      </div>
                      <div className="col-4 py-2">
                        <Input
                          name={`${index}dfnotes`}
                          label=""
                          onChange={(e) =>
                            handleChange(
                              e,
                              "DocumentationFidelity",
                              index,
                              "notes"
                            )
                          }
                          value={data.DocumentationFidelity[index]["notes"]}
                          disabled={isNotSupervisor || supervisorSigned}
                        />
                      </div>
                      <div className="col-4 py-2">
                        <Input
                          name={`${index}dffollowup`}
                          label=""
                          onChange={(e) =>
                            handleChange(
                              e,
                              "DocumentationFidelity",
                              index,
                              "followup"
                            )
                          }
                          value={data.DocumentationFidelity[index]["followup"]}
                          disabled={isNotSupervisor || supervisorSigned}
                        />
                      </div>
                      <div className="col-1 py-2">
                        {!isNotSupervisor && !supervisorSigned && (
                          <i
                            className="fas fa-times-circle fa-lg text-danger"
                            onClick={(e) => {
                              let obj = { ...data };
                              obj.DocumentationFidelity.splice(index, 1);
                              setData(obj);
                            }}
                            disabled={isNotSupervisor || supervisorSigned}
                          ></i>
                        )}
                      </div>
                    </div>
                  );
                })
              : null}
          </div>
        </div>
      ) : null}
      {data && data.AdministrativeSupervision === true ? (
        <div className="my-4 border rounded p-2 bg-light">
          <div className="row p-2">
            <div className="h5 col-9">Administrative Supervision</div>
            <div className="col-3">
              {!isNotSupervisor && !supervisorSigned && (
                <div
                  className="btn btn-success float-end"
                  onClick={addAdministration}
                  disabled={isNotSupervisor || supervisorSigned}
                >
                  Add
                </div>
              )}
            </div>
          </div>
          <div className="mx-4 mb-4">
            <div className="row bg-safy2-1 text-white">
              <div className="col-3  py-2">Item</div>
              <div className="col-4  py-2">Notes</div>
              <div className="col-4  py-2">Follow-Up</div>
              <div className="col-1  py-2"></div>
            </div>
            {data && data.Administration
              ? data.Administration.map((item, index) => {
                  return (
                    <div className="row border bg-white" key={`as${index}`}>
                      <div className="col-3 py-2">
                        <Select
                          name={`${index}asItem`}
                          options={[
                            { id: "utilization", name: "Utilization" },
                            { id: "trainingNeeds", name: "Training Needs" },
                            { id: "fileCompliance", name: "File Compliance" },
                            { id: "forms", name: "Forms" },
                            { id: "ebp", name: "EBP Compliance" },
                            { id: "concur", name: "Concur" },
                            { id: "adp", name: "ADP" },
                            { id: "performance", name: "Performance" },
                            { id: "other", name: "Other" },
                          ]}
                          value={data.Administration[index]["item"]}
                          onChange={(e) =>
                            handleChange(e, "Administration", index, "item")
                          }
                          disabled={isNotSupervisor || supervisorSigned}
                        />
                        {data &&
                        data.Administration &&
                        data.Administration[index]["item"] === "Other" ? (
                          <Input
                            name={`${index}asOther`}
                            label="Other (specify)"
                            onChange={(e) =>
                              handleChange(e, "Administration", index, "other")
                            }
                            value={data.Administration[index]["other"]}
                            disabled={isNotSupervisor || supervisorSigned}
                          />
                        ) : null}
                      </div>
                      <div className="col-4 py-2">
                        <Input
                          name={`${index}asnotes`}
                          label=""
                          onChange={(e) =>
                            handleChange(e, "Administration", index, "notes")
                          }
                          value={data.Administration[index]["notes"]}
                          disabled={isNotSupervisor || supervisorSigned}
                        />
                      </div>
                      <div className="col-4 py-2">
                        <Input
                          name={`${index}asfollowup`}
                          label=""
                          onChange={(e) =>
                            handleChange(e, "Administration", index, "followup")
                          }
                          value={data.Administration[index]["followup"]}
                          disabled={isNotSupervisor || supervisorSigned}
                        />
                      </div>
                      <div className="col-1 py-2">
                        {!isNotSupervisor && !supervisorSigned && (
                          <i
                            className="fas fa-times-circle fa-lg text-danger"
                            onClick={(e) => {
                              let obj = { ...data };
                              obj.Administration.splice(index, 1);
                              setData(obj);
                            }}
                            disabled={isNotSupervisor || supervisorSigned}
                          ></i>
                        )}
                      </div>
                    </div>
                  );
                })
              : null}
          </div>
        </div>
      ) : null}
      <Input
        name="SelfCare"
        label="Self-Care/Wellness "
        onChange={handleChange}
        value={data.SelfCare}
        disabled={isNotSupervisor || supervisorSigned}
      />
      <Input
        name="OtherComments"
        label="Other Comments"
        onChange={handleChange}
        value={data.OtherComments}
        disabled={isNotSupervisor || supervisorSigned}
      />
      <div
        className="text-safy-info"
        style={{ cursor: "pointer" }}
        onClick={() =>
          window.open(
            "https://survey.alchemer.com/s3/6727286/Professional-Quality-of-Life-Measure-ProQOL-5-0"
          )
        }
      >
        Link to ProQOL-5
      </div>
      <div className="border rounded my-4 p-2 bg-light">
        <div className="h4">Comment History</div>
        <div className="my-4">
          {data && data.Comments
            ? data.Comments.map((c, index) => (
                <div className="m-4" key={`comment${index}`}>
                  <div
                    className={`row ${
                      safyInfo.user.displayName === c.createdBy &&
                      "justify-content-end"
                    }`}
                  >
                    <div className="col-4 h6">{`${c.createdBy} - ${new Date(
                      c.createdOn
                    ).toLocaleString()}`}</div>
                  </div>
                  <div className="border rounded bg-white p-2">{`${c.message}`}</div>
                </div>
              ))
            : null}
        </div>
        <div className="mb-4 pb-4">
          <Input
            name="addComment"
            label="Add Comment"
            onChange={handleChange}
            value={data.addComment}
          />
        </div>
        <div className="row m-2">
          <div className="col">
            <div
              className="btn btn-success float-end mb-4"
              onClick={() => addComment()}
            >
              Add
            </div>
          </div>
        </div>
      </div>
      <div className="h4 mt-4">Signatures</div>
      <div>
        {data.SupervisorUser &&
          data.SupervisorUser.toLowerCase() ===
            safyInfo.user.domainName.split("\\")[1].toLowerCase() &&
          !supervisorSigned && (
            <>
              <button
                className="btn btn-success ps-4 m-2"
                onClick={() => handleSign("Supervisor")}
                disabled={
                  !data.LengthOfSupervision || data.LengthOfSupervision === "0"
                }
              >
                Sign as Supervisor
              </button>
              {(!data.LengthOfSupervision ||
                data.LengthOfSupervision === "0") &&
                "* Length of Supervision Session is required before signing"}
            </>
          )}
        {supervisorSigned && (
          <div className="border rounded p-2 m-2 bg-success text-white">
            <div>{`Supervisor: ${data.Signatures.signatures[0].name}`}</div>
            <div>
              {`Date: ${
                data.Signatures.signatures[0].date &&
                new Date(data.Signatures.signatures[0].date).toDateString()
              }
              `}
            </div>
          </div>
        )}
      </div>
      <div>
        {data.SuperviseeUser &&
          data.SuperviseeUser.toLowerCase() ===
            safyInfo.user.domainName.split("\\")[1].toLowerCase() &&
          !superviseeSigned && (
            <>
              <button
                className="btn btn-success ps-4 m-2"
                onClick={() => handleSign("Supervisee")}
                disabled={
                  !data.LengthOfSupervision || data.LengthOfSupervision === "0"
                }
              >
                Sign as Supervisee
              </button>
              {(!data.LengthOfSupervision ||
                data.LengthOfSupervision === "0") &&
                "* Length of Supervision Session is required before signing"}
              {data.LengthOfSupervision &&
                data.LengthOfSupervision !== "0" &&
                "By signing this supervision log, I agree with content and next steps outlined."}
            </>
          )}
        {superviseeSigned && (
          <div className="border rounded p-2 m-2 bg-success text-white">
            <div>{`Supervisee: ${data.Signatures.signatures[1].name}`}</div>
            <div>
              {`Date: ${
                data.Signatures.signatures[1].date &&
                new Date(data.Signatures.signatures[1].date).toDateString()
              }
              `}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default IndividualSupervisionLog;
